import "./Views.css";
import NavigationToggle from "@arcgis/core/widgets/NavigationToggle";
import Zoom from "@arcgis/core/widgets/Zoom";
import Home from "@arcgis/core/widgets/Home";
import Locate from "@arcgis/core/widgets/Locate";
import Compass from "@arcgis/core/widgets/Compass";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";

import Slice from "@arcgis/core/widgets/Slice";
import Expand from "@arcgis/core/widgets/Expand";

import VoxelSlice from "@arcgis/core/layers/voxel/VoxelSlice";

import ExtentHistory from "./ExtentHistory";
import FlightMode from "./FlightMode";
import ScreenShot from "./ScreenShot";
import GetArcGISToken from "utils/GetArcGISToken";
import config from "config";

import SearchResult from "components/SearchResult/SearchResult";

const MAP_UI_STYLE_LIST = [
  { type: "widget", clsname: "esri-zoom", stylename: "top-radius" },
  {
    type: "widget",
    clsname: "esri-navigation-toggle",
    stylename: "bottom-radius",
  },
  { type: "widget", clsname: "esri-home", stylename: "top-radius" },
  { type: "widget", clsname: "esri-compass", stylename: "bottom-radius" },
  { type: "button", clsname: "icn_tool_backwards", stylename: "top-radius" },
  {
    type: "button",
    clsname: "icn_3d_Elevationprofile_clearall",
    stylename: "bottom-radius",
  },
  { type: "button", clsname: "icn_tool_split", stylename: "top-radius" },
  { type: "button", clsname: "icn_tool_fly", stylename: "bottom-radius" },
  {
    type: "button",
    clsname: "icn_tool_legend",
    stylename: "top-radius bottom-radius",
  },
];

const MAP_UI_ITEM_LIST = [
  { type: "widget", objectClass: Zoom },
  { type: "widget", objectClass: NavigationToggle, is3D: true },
  { type: "space" },
  { type: "widget", objectClass: Home, label: "Home" },
  { type: "widget", objectClass: Locate },
  { type: "widget", objectClass: Compass },
  { type: "space" },
  {
    type: "button",
    icon: "icn_tool_backwards",
    func: () => MapUI.histObj.previousExtent(),
    label: "Previous Extent",
  },
  {
    type: "button",
    icon: "icn_tool_forward",
    func: () => MapUI.histObj.nextExtent(),
    label: "Next Extent",
  },

  {
    type: "button",
    icon: "icn_3d_Elevationprofile_clearall",
    label: "Clear all graphics",
    func: (view) => {
      let tmp_lds = view.map.findLayerById("LDS-Sensors");
      let tmp_uav_pt = view.map.allLayers._items.find(
        (i) => i.title == "UAV Image Point"
      );
      let tmp_uav_path = view.map.allLayers._items.find(
        (i) => i.title == "UAV Flight Path"
      );

      tmp_lds && (tmp_lds.definitionExpression = "1=2");
      tmp_uav_path && (tmp_uav_path.definitionExpression = "1=2");
      tmp_uav_pt && (tmp_uav_pt.definitionExpression = "1=2");

      view.map.allLayers.forEach((i) => i.type === "graphics" && i.removeAll());
      view.graphics.removeAll();

      SearchResult.updateSearchResultObject([], false, undefined);
    },
  },
  { type: "space" },
  {
    type: "button",
    icon: "icn_tool_split",
    callbackCode: "splitScreen",
    label: "Split Screen",
  },
  {
    type: "button",
    icon: "icn_tool_Elevationprofile",
    callbackCode: "toggle3DElevation",
    // is3D: true,
    label: "Elevation Profile",
  },
  {
    type: "expand",
    icon: "icn_tool_slice",
    objectClass: Slice,
    is3D: true,
    label: "Slice Tool",
  },
  {
    type: "expand",
    icon: "icn_menu_overlay",
    is3D: false,
    position: "manual",
    label: "Shortcut Layer",
    secondCol: true,
  },
  {
    type: "expand",
    icon: "icn_featurelayer",
    is3D: true,
    position: "manual",
    label: "3D Layer Panel",
    secondCol: true,
    customID: "3DLayerSearchResult",
  },
  {
    type: "button",
    icon: "icn_mail",
    callbackCode: "togglemail",
    label: "Suggestion / Query",
    position: "manual",
    secondCol: true,
  },
  {
    type: "button",
    icon: "icn_summarize",
    callbackCode: "togglesummaryReport",
    label: "Summary Report",
    position: "manual",
    secondCol: true,
    userGroups: [1, 2, 8],
  },
  {
    type: "button",
    icon: "icn_black_24dp",
    callbackCode: "togglelastUpdatedDate",
    label: "Last Updated Date",
    position: "manual",
    secondCol: true,
  },
  {
    type: "button",
    icon: "icn_streetview",
    callbackCode: "toogleGoogleStreetView",
    label: "Google Street View",
    position: "manual",
    secondCol: true,
  },
  {
    type: "button",
    icon: "icn_3d_camera",
    callbackCode: "toggleArielPhoto",
    label: "Aerial Photo",
    position: "manual",
    secondCol: true,
    userGroups: [1, 2, 8],
  },
  {
    type: "button",
    icon: "icn_tool_airplane",
    func: () => MapUI.flightObj.toggleFlyMode(),
    is3D: true,
    label: "Flight Mode",
  },
  {
    type: "button",
    icon: "icn_elevation",
    callbackCode: "toggleElevation",
    is3D: true,
    label: "Turn off Elevation",
  },
  {
    type: "button",
    icon: "icn_tool_legend",
    callbackCode: "toggleLegend",
    position: "bottom-right",
    label: "Legend",
  },
  {
    type: "widget",
    objectClass: ScaleBar,
    position: "bottom-left",
    label: "Scale Bar",
  },
  // {
  //   type: "button",
  //   icon: "icn_tool_Elevationprofile",
  //   callbackCode: "toggle3DElevation",
  //   // is3D: true,
  //   label: "Elevation Profile",
  //   secondCol: true,
  // },
];

const MAP_UI_ACTION_BTNS_3D = [
  {
    label: "Bookmark Manager",
    icon: "icn_3d_bookmark",
    command: "showBookmarkPanel",
  },
  {
    label: "Take map snapshot",
    icon: "icn_3d_camera",
    func: () => MapUI.screenCapObj.capture(),
  },
  {
    label: "Recorder",
    icon: "icn_3d_record",
    command: "showRecorderPanel",
    // is3DOnly: true,
  },
  {
    label: "Switch to 2D",
    icon: "icn_3d_goto2d",
    command: "switchMapModeTo2D",
    // is3DOnly: true,
  },
];

const MAP_UI_ACTION_BTNS_2D = [
  {
    label: "Bookmark Manager",
    icon: "icn_3d_bookmark",
    command: "showBookmarkPanel",
  },
  {
    label: "Printer",
    icon: "icn_2d_printer",
    command: "Printer",
  },
  {
    label: "Switch to 3D",
    icon: "icn_2d_goto3d",
    command: "switchMapModeTo3D",
  },
];

const ITEMS_COMPACT_ONLY = [0, 1, 2, 3, 4];
class MapUI {
  static lastExtent = undefined;
  static histObj = new ExtentHistory();
  static flightObj = new FlightMode();
  static screenCapObj = new ScreenShot();

  static createUI(view, is3D, callback, isCompactMode = false) {
    if (!isCompactMode) {
      // When the page is freshly loaded
      const user = GetArcGISToken.user.displayName;

      var nameplate = document.createElement("DIV");
      nameplate.className = "nameplate";
      // nameplate.innerHTML = "Welcome, Lee Dai Wen";
      nameplate.innerHTML = "Welcome, " + (user || "Guest");
      view.ui.add(nameplate, "top-right");

      var actionBtns = document.createElement("DIV");
      actionBtns.className = "actionBtns spacer EqualWidthChildren";
      view.ui.add(actionBtns, "top-right");

      var secondCol = document.createElement("DIV");
      secondCol.className = "mapUISecondCol esri-ui-corner";
      view.ui.add(secondCol, "top-right");

      // console.log("check",is3D);
      let actionBtnList = is3D ? MAP_UI_ACTION_BTNS_3D : MAP_UI_ACTION_BTNS_2D;
      {
        actionBtnList.forEach((i) => {
          var btn = document.createElement("DIV");
          var spanBtn = document.createElement("SPAN");
          btn.appendChild(spanBtn);
          spanBtn.className = i.icon + " IconColor2";
          spanBtn.title = i.label;
          btn.addEventListener("click", () => {
            if (i.func) i.func(view);
            else callback(i.command);
          });
          actionBtns.appendChild(btn);
        });
      }

      MapUI.histObj.updateMapView(view);
      MapUI.flightObj.mapView = view;
      MapUI.flightObj.toggleFlyMode(false);
      MapUI.screenCapObj.mapView = view;
    }

    var space = document.createElement("DIV");
    space.className = "spacer";
    var button = document.createElement("DIV");
    button.className = "esri-component esri-widget--button esri-widget ";

    const prop = { view };

    const userGroup = GetArcGISToken.user.userGroup;

    MAP_UI_ITEM_LIST.forEach(function(i, j) {
      if (!ITEMS_COMPACT_ONLY.includes(j) && isCompactMode) return;
      if (i.is3D && !is3D) return;
      if (i.userGroups && !i.userGroups.includes(userGroup)) return;
      let addItem = null;
      switch (i.type) {
        case "space":
          addItem = space.cloneNode();
          break;
        case "widget":
          addItem = new i.objectClass(prop);
          break;
        case "button":
          addItem = button.cloneNode();
          addItem.addEventListener(
            "click",
            function(item) {
              if (item.func) item.func(view);
              else callback(item.callbackCode);
            }.bind(this, i)
          );
          addItem.title = i.label;
          break;
        case "expand":
          let content = null;
          addItem = new Expand({
            expandIconClass: i.icon,
            expandTooltip: i.label,
            mode: "floating",
          });

          addItem.watch("expanded", (newV, oldV) => {
            if (newV) {
              var expandContainer = document.createElement("DIV");

              if (i.label === "Shortcut Layer") {
                callback("toggleShortcutPanel", {
                  expandContainer: expandContainer,
                });
              } else if (i.label === "3D Layer Panel") {
                callback("toggle3DlayerPanel", {
                  expandContainer: expandContainer,
                });
              } else {
                content = new i.objectClass({
                  ...prop,
                  container: expandContainer,
                });
              }
              addItem.content = expandContainer;
              if (i.label === "Slice Tool") {
                content.viewModel.tiltEnabled = true;
                MapUI.sliceVoxelHandler(content, view);
              }
            } else {
              if (i.label === "Shortcut Layer") {
                callback("toggleShortcutPanel", { expandContainer: null });
              } else if (i.label === "3D Layer Panel") {
                callback("toggle3DlayerPanel", { expandContainer: null });
              } else {
                content.destroy();
                if (i.label === "Slice Tool")
                  view.map.allLayers
                    .filter((i) => i.type == "voxel")
                    .forEach((i) => MapUI.removeVoxelStyle(i));
              }
            }
          });
          break;
      }
      if (i.type == "button") {
        var span = document.createElement("SPAN");
        span.className = i.icon;
        addItem.appendChild(span);
      }
      if (i.label === "Home") {
        addItem.viewModel.viewpoint = { targetGeometry: config.FULL_EXTENT };
        addItem.goToOverride = (view, goToParams) => {
          goToParams.options.animate = false;
          return view
            .goTo(goToParams.target, goToParams.options)
            .then(() => view.goTo({ tilt: 0.5 }));
        };
      }
      if (i.secondCol) {
        let widgetObj = addItem;
        let con1 = document.createElement("DIV");
        if (widgetObj.declaredClass) {
          widgetObj.container = con1;
          widgetObj.when(() => {
            widgetObj.domNode.classList.add(`esri-component`);
            if (typeof i.customID !== "undefined") {
              widgetObj.domNode.id = i.customID;
            }
          });
        } else if (i.type !== "button") {
          widgetObj.classList.add(`esri-component`);
          con1.appendChild(widgetObj);
        } else {
          con1 = addItem;
        }

        secondCol.appendChild(con1);
        return;
      }
      if (i.label === "Scale Bar") {
        addItem.unit = "metric";
      }
      view.ui.add(addItem, i.position || "top-right");
    });
    view.when((_) => {
      MAP_UI_STYLE_LIST.forEach(function(i) {
        const n = document.getElementsByClassName(i.clsname);
        if (n && n.length >= 1) {
          if (i.type == "widget") {
            n[n.length - 1].classList += " " + i.stylename;
          } else if (i.type == "button") {
            n[n.length - 1].parentElement.classList += " " + i.stylename;
          }
        }
      });
    });
  }

  static removeVoxelStyle(voxelLayer) {
    let SliceStyle = voxelLayer.volumeStyles.getItemAt(0);
    SliceStyle && SliceStyle.slices.removeAll();
  }

  static sliceVoxelHandler(slice, mapView) {
    slice.viewModel.watch("shape", (newV, oldV) => {
      // console.debug(newV, oldV);
      // if (newV === "slicing" || newV === "sliced") {
      let voxelLayers = mapView.map.allLayers.filter((i) => i.type == "voxel");
      if (!!newV) {
        let slicePlate = slice.viewModel.shape;
        let plateCenterPt = slice.viewModel.shape.position;
        voxelLayers.forEach((voxelLayer) => {
          let vol3dVolumeInfo = voxelLayer.volumes.items[0];
          let vol3dSize = vol3dVolumeInfo.sizeInVoxels;
          let vol3dPtArr = vol3dVolumeInfo.originInLayerSpace3D;
          let voxelExtent = voxelLayer.fullExtent;
          let voxelOx = vol3dPtArr[0];
          let voxelOy = vol3dPtArr[1];
          let voxelOz = vol3dPtArr[2];
          let voxelW = vol3dSize[0];
          let voxelH = vol3dSize[1];
          let voxelD = vol3dSize[2];

          let platePtXInVoxel = plateCenterPt.x - voxelOx;
          let platePtYInVoxel = voxelOy - plateCenterPt.y;

          let platePtXPercentage = platePtXInVoxel / voxelW;
          let platePtYPercentage = platePtYInVoxel / voxelH;

          // console.debug(voxelW, platePtXInVoxel, platePtXPercentage);
          // console.debug(voxelH, platePtYInVoxel, platePtYPercentage);

          if (
            platePtXPercentage < 0 ||
            platePtXPercentage > 1 ||
            platePtYPercentage < 0 ||
            platePtYPercentage > 1
          ) {
            console.debug("Out of range");
            MapUI.removeVoxelStyle(voxelLayer);
            return;
          }

          // console.debug(
          //   slicePlate.height,
          //   slicePlate.position.z,
          //   slicePlate.height / 2 + slicePlate.position.z
          // );

          // console.debug(slicePlate);

          MapUI.sliceFunc(
            slicePlate.heading,
            slicePlate.tilt,
            [
              platePtXInVoxel,
              platePtYInVoxel,
              /*
            slicePlate.tilt < 10 ? 
              Math.abs(voxelOz) + slicePlate.position.z : 
              0,
            */
              plateCenterPt.z - voxelOz,
              // slicePlate.height / 2 + slicePlate.position.z,
            ],
            voxelLayer
          );
        });
      } else {
        voxelLayers.forEach((voxelLayer) => MapUI.removeVoxelStyle(voxelLayer));
      }
    });
  }

  static sliceFunc(orientation, tilt, point, voxelLayer) {
    let vxlSlice = new VoxelSlice({
      orientation,
      tilt,
      point,
    });

    // console.log("slice", vxlSlice);
    // console.log("variables", voxelLayer.variables);

    const newVolStyles = voxelLayer.volumeStyles.clone();
    const newVolStyle0 = newVolStyles.getItemAt(0);
    newVolStyle0.slices.removeAll();
    //newVolStyle0.verticalExaggeration = 1;
    // if (newVolStyle0.slices.length <= 0) {
    newVolStyle0.slices.add(vxlSlice);
    // } else {
    //   var tmpslice = newVolStyle0.slices.getItemAt(0);
    //   tmpslice.point = vxlSlice.point;
    // }
    voxelLayer.volumeStyles = newVolStyles;
  }
}

export default MapUI;
